import { useMemo } from "react";
import { useSelector } from "react-redux";
import { buildPermissionChecker, selectPermissions } from "../components/toolkit/permissions";

export const useCan = () => {
  const list = useSelector(selectPermissions);
  const can = useMemo(() => buildPermissionChecker(list), [list]);
  return can;
};

export const canFrom = (permissionsList) => buildPermissionChecker(permissionsList);


